import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ForgotPasswordService } from './forgot-password.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  formForgot: FormGroup;
  wait = false;
  response = '';
  typeResponse ='';

  constructor(private fps:ForgotPasswordService) {
    this.formForgot = new FormGroup({
      email: new FormControl('',
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9\._-]+@[a-zA-Z0-9-]{2,}([.][a-zA-Z]{2,64}){1,64}$')
        ]
      )
    });
  }

  ngOnInit() {
  }

  submitForgot() {
    this.wait = true;
    this.typeResponse = '';
    this.fps.sendForgotRequest(this.formForgot.value).subscribe(
      (response)=>{
        this.typeResponse = 'info';
        this.wait = false;
        const message = Object(response)['data'].message;
        this.response = message;
        this.formForgot.get('email').setValue('');
      },
      (error)=>{
        this.typeResponse = 'danger';
        this.wait = false;
        const message = Object(error)['error'].message;
        this.response = message;
      }
    )
  }

}
